import React, { useContext, useEffect, useRef, useState } from "react";

import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ConfigContext } from "../../Context/ConfigContext";

import { useParams } from "react-router-dom";
import { Spinner } from "../../Components/Shimmers";
import slugify from "slugify";
import Carousel from "react-multi-carousel";
import 'react-multi-carousel/lib/styles.css';
import { Helmet } from "react-helmet";
import UniCarSearch from "../Cars/UniCarSearch";
import PartsHorizontalCard from "../../Components/Cards/PartsHorizontalCard";
import ClipLoader from "react-spinners/ClipLoader";
import { AddToCart, GetCartItemQty, GetCarts } from "../../Helper/MyCart";
import { ToastContainer, toast } from 'react-toastify';

import { AddToCartNotifier } from "../../Components/CartComponents";
import CarInfoBox from "../Cars/CarInfoBox";

const ByDepartment = () => {
  const { currency, apiURL, apiB2BURL, setCartItemsQty, isUserInternational, setIsCartDropdownOpen, token } = useContext(ConfigContext);
  const location = useLocation();
  const { t } = useTranslation();
  const locale = localStorage.getItem("lang") ?? "en";
  const { gdcURL } = useContext(ConfigContext);
  const dir = localStorage.getItem("dir");
  var { STR_ID, STR_NODE_NAME } = useParams();
  const [loading, setLoading] = useState(false);
  const [parts, setParts] = useState([]); 

  const [TotalParts, setTotalParts] = useState(0);
  const [CurrentPage, setCurrentPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [TotalPages, setTotalPages] = useState(0);
  const [page, setPage] = useState(1);
  const [keyword, setKeyword] = useState("");
  const [infos, setInfos] = useState([]);
  const [oes, setOES] = useState([]);
  const [add_to_cart_status, setAdd_to_cart_status] = useState(false);
  const [lockStatus, setLockStatus] = useState(false);
  const navigate = useNavigate();
 useEffect(() => { 
    LoadParts();
    window.scrollTo(0, 0);
 }, [page])
 const goToPage = (pageNum) => {
    
    if (pageNum >= 0 && pageNum <= TotalPages) {
      setPage(pageNum);
    }
  };
  const LoadParts = () => {
      setLoading(true);
      fetch(`${apiB2BURL}/Customer/Parts/GetPartsByCondition?part_number=${keyword}&str_id=${STR_ID}&limit=${limit}&page=${page}`)
        .then((res) => res.json())
        .then((data) => {
          setParts(data.data);
          // setTotalPages(data.total_pages);
          // setTotalParts(data.total_records);
          setLoading(false);

        })
        .catch((error) => {
          console.error("Fetch error:", error);
          setLoading(false);
        });
  }

  useEffect(() => {
    setParts([])
    LoadParts();
  }, []);

  

 
  let [color, setColor] = useState("#ffffff");
  const handeSearch = () => {
    LoadParts();
    setLockStatus(true);
  }

  const renderPageNumbers = () => {
    const pages = [];
    for (let i = 1; i <= TotalPages; i++) {
      pages.push(
        <li key={i} className={`page-item ${page === i ? 'active' : ''}`}>
          <button className="page-link" onClick={() => goToPage(i)}>
            {i}
          </button>
        </li>
      );
    }
    return pages;
  };

  const handleAddToCart = async (item, url) => {
    var prev_qty = await GetCartItemQty(item.ART_ARTICLE_NR);
    
    if (Number(1) >= Number(1) + prev_qty) {
      

      setAdd_to_cart_status(true)
      

      await AddToCart(item.ART_ID, item.ART_ARTICLE_NR, item.PRODUCT_GROUP_EN, item.VD_PRICE_MRP, item.VD_BB_PRICE, 1, `${apiURL}/public/placeholder_category.jpeg`, url, 1, item.stock_sup_id ?? 0, apiB2BURL, token);
      setCartItemsQty();
      setIsCartDropdownOpen(true);
      window.scrollTo(0, 0);
      
    } else {
      toast.success(<AddToCartNotifier item_name={t('sorry_we_have_only', { value: 1 })} item_img={''} />, {})
    }

    // console.log(item.ART_ID, item.ART_ARTICLE_NR, item.PRODUCT_GROUP_EN, item.VD_PRICE_MRP, item.VD_BB_PRICE, 1, `${apiURL}/public/placeholder_category.jpeg`, url, 1)
   

  }
  return (
    <div
    className="header-bottom  d-none d-lg-block"
    style={{
      borderBottom: "1px solid rgb(226, 226, 226)",
      marginBottom: "10px",
    }}>
      <Helmet>
        <title>Shop By {STR_NODE_NAME.replaceAll('-', '')}</title>
      </Helmet>
    <div className="container">
    
      <nav
        className="main-nav w-100"
        style={{ textAlign: dir === "rtl" ? "right" : "left" }}>
          <div className="row justify-content-center">
          <div className="col-md-11">
            <CarInfoBox />
          </div>
            <div className="col-md-11">
                <div className="row justify-content-end">
                    <div className="col-md-8"><h4 className="mt-3">{STR_NODE_NAME.replaceAll('-', '')} Part List</h4></div>
                    <div className="col-md-4">
                    <div className="d-flex align-items-center mt-2"> {/* Added a flex container */}
                            <input readOnly={lockStatus} type="text" onChange={(e) => setKeyword(e.target.value)} className="form-control me-2" placeholder="Enter part number" value={keyword}/> 
                            <button onClick={() => handeSearch()} type="button" className="btn btn-primary"  style={{marginTop: '-10px', padding: '12px'}}>Search</button>
                            <button onClick={() => {
                              setLockStatus(false);
                              setKeyword("");
                              handeSearch();
                            }} type="button" className="btn btn-dark"  style={{marginTop: '-10px', padding: '12px'}}>Clear</button>
                        </div>
                    </div>
                </div>
               <table className="table table-striped table-bordered">
                <thead>
                <tr>
                    <th width="400">Brand</th>
                    <th style={{minWidth: '150px'}}>Part Number</th>
                    <th>Available QTY</th>
                    <th>MRP Price</th>
                    <th>Offer Price</th>
                    <th>Total Saving</th>
                    <th>Info</th>
                    <th>Buy</th>
                </tr>
                </thead>
                <tbody>
                {
                    parts.map((part) => {
                      var url = '/Spare-Parts/Details/'+slugify(`${part.PRODUCT_GROUP_EN}`.toLowerCase()) +
                      "-" +
                      slugify(`${part.ART_SEARCH_NUMBER}`.toLowerCase()) +
                      "-" +
                      part.STR_ID +
                      "-" +
                      slugify(`${part.ART_SUP_ID}`.toLowerCase()) +
                      "-" +
                      slugify(`${part.ART_ID}`.toLowerCase());

                        return <tr>
                            <td width="20%"><NavLink to={url}>{part.ART_SUP_BRAND}</NavLink></td>
                            <td width="10%">{part.ART_ARTICLE_NR}</td>
                            <td>{part.VD_QTY}</td>
                            <td><del>{part.VD_PRICE_MRP} AED</del></td>
                            <td>{part.VD_BB_PRICE} AED</td>
                            <td><span className="badge bg-success" style={{color: '#FFF'}}>{part.VD_PRICE_MRP - part.VD_BB_PRICE} AED</span></td>
                            <td>
                                {/* <button  
                                onClick={() => setInfos(part.ARTICLE_CRITERIA)}
                                data-toggle="modal"
                                data-target="#infoModal" 
                                className="btn btn-sm btn-info"> <i className="fas fa-info-circle"></i> Info </button> */}
                                <button onClick={() => navigate(url)}  className="btn btn-sm btn-info"> <i className="fas fa-info-circle"></i> Info </button>
                                <button 
                                onClick={() => setOES(part.OEM_NUMBERS)}
                                data-toggle="modal"
                                data-target="#OEModal" 
                                className="btn btn-sm btn-primary"> <i className="fas fa-list"></i> OE Numbers </button>
                                
                            </td>
                            <td><button 
                            
                            className="btn btn-sm btn-dark" type="button" onClick={() => handleAddToCart(part, url)}> <i className="fas fa-cart-plus"></i> Buy </button></td>
                        </tr>
                    })
                }
                </tbody>
               </table>
               <div
                    className="modal fade"
                    id="infoModal"
                    tabIndex={-1}
                    role="dialog"
                    aria-labelledby="infoModalLabel"
                    aria-hidden="true" style={{zIndex: 1000000}}
                  >
                    <div className="modal-dialog modal-sm" role="document" style={{width: 500}}>
                      <div className="modal-content">
                        
                        <div className="modal-body">
                        <button
                            type="button"
                            className="close"
                            data-dismiss="modal"
                            aria-label="Close"
                          >
                            <span aria-hidden="true">×</span>
                          </button>
                          <table className="table table-bordered table-striped mt-3">
                          {
                            infos.map((info) => {
                              return <tr><th>{info.criteria_en}</th><td>{info.value_en}</td></tr>
                            })
                          }
                          </table>

                        </div>
                        
                      </div>
                    </div>
                  </div>


                  <div
                    className="modal fade"
                    id="OEModal"
                    tabIndex={-1}
                    role="dialog"
                    aria-labelledby="OEModalLabel"
                    aria-hidden="true" style={{zIndex: 1000000}}
                  >
                    <div className="modal-dialog modal-sm" role="document" >
                      <div className="modal-content">
                        
                        <div className="modal-body">
                        <button
                            type="button"
                            className="close"
                            data-dismiss="modal"
                            aria-label="Close"
                          >
                            <span aria-hidden="true">×</span>
                          </button>

                          <h4>Compatible OE Numbers</h4>
                          <div className="row ">
                          {
                            oes.map((oe) => {
                              return <div className="col-md-4 mt-2">
                              <NavLink style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', fontSize: '12px' }}>
                                <div 
                                  style={{ 
                                    width: '8px', 
                                    height: '8px', 
                                    borderRadius: '50%', 
                                    backgroundColor: 'rgb(204, 0, 10)' 
                                  }} 
                                />
                                <small>{oe.ARL_BRA_BRAND} - {oe.ARL_DISPLAY_NR}</small>
                              </NavLink>
                            </div>
                            })
                          }
                          </div>

                        </div>
                        
                      </div>
                    </div>
                  </div>

               <nav>
                <ul className="pagination justify-content-center">
                    <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
                    <button className="page-link" onClick={() => goToPage(page - 1)}>
                        Previous
                    </button>
                    </li>
                    {renderPageNumbers()}
                    <li className={`page-item ${page === TotalPages ? 'disabled' : ''}`}>
                    <button className="page-link" onClick={() => goToPage(page + 1)}>
                        Next
                    </button>
                    </li>
                </ul>
                </nav>
            </div>
          </div>
          
      </nav>
    </div>
    {/* End .container */}
  </div>
  )

};
const ImageWithFallback = ({ src, index, alt, fallbackText, OE }) => {
  const [imgError, setImgError] = useState(false);

  const handleError = () => {
    setImgError(true);
  };
  const fallbackStyle = {
    textAlign: "center",
    fontSize: "10px",
    padding: "10px",
    wordBreak: "break-word",
    maxWidth: "90%",
  };

  const containerStyle = {
    position: "relative",
    width: "100%",
    height: "30px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };
  return (
    <div style={containerStyle}>
      {imgError ? (
        <div style={fallbackStyle}>{fallbackText}</div>
      ) : (
        <img
          draggable="false"
          style={{
            height: "30px",
            margin: "auto",
            float: "none",
            marginTop: OE === false ? "5px" : 0,
          }}
          key={`img-part-${index}`}
          src={src}
          alt={alt}
          onError={handleError}
        />
      )}
    </div>
  );
};
export default ByDepartment;

